/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef, useCallback, useState } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useToast } from '../../../../hooks/toast';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import { Container } from './styles';
import File from '../../../../components/File';
import RechargeService from '../../../../services/recharge';
import AuthService from '../../../../services/auth';

interface CreateOrderByImportProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleAdd(): void;
}

const schema = Yup.object().shape({
  ArquivoImportacao: Yup.string().required('O arquivo é obrigatório'),
});

const CreateOrderByImport: React.FC<CreateOrderByImportProps> = ({
  handleClose,
  handleAdd,
  show,
  title,
}) => {
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { addToast } = useToast();
  const services = { RechargeService: new RechargeService() };
  const [errors, setErrors] = useState<any>([]);
  const [titular, setTitular] = useState<any>();
  const authService = { AuthService: new AuthService() };
  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  const handleSubmit = useCallback(async (data: any) => {
    setLoading(true);
    try {
      formRef.current?.setErrors({});

      await schema.validate(data, {
        abortEarly: false,
      });

      const formData = new FormData();

      for (const name in data) {
        if (Object.prototype.hasOwnProperty.call(data, name)) {
          formData.append(name, data[name]);
        }
      }

      const response = await services.RechargeService.rechargeImport(formData);

      handleAdd();

      setLoading(false);

      if (response.data.ErrosImportacao !== null) {
        setErrors(
          response?.data?.Summary?.ErrorCollection?.DataValidationErros,
        );
      } else if (
        response.data.Summary.ErrorCollection.DataValidationErros.length
      ) {
        setErrors(response.data.Summary.ErrorCollection.DataValidationErros);
      }
      if (response.data.Summary.Success) {
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Importação em massa feita com sucesso!!',
        });
      }
    } catch (err: any) {
      setLoading(false);
      const { ...error } = err;
      setErrors([]);

      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
        return;
      }

      if (typeof error.response.data !== 'string') {
        if (error.response.data.ErrosImportacao !== null) {
          setErrors(error.response.data.ErrosImportacao);
        }
        if (
          error.response.data.Summary.ErrorCollection.DataValidationErros[0]
        ) {
          addToast({
            type: 'error',
            title:
              error.response.data.Summary.ErrorCollection.DataValidationErros[0]
                .ErrorMessage,
            description:
              error.response.data.Summary.ErrorCollection.DataValidationErros[0]
                .InternalErrorMessage,
          });
        }
      } else {
        addToast({
          type: 'error',
          title: 'Erro interno do servidor',
        });
      }
    }
  }, []);

  function importFile() {
    window.open('/files/pedidoderecarga.txt');
  }

  function importFilecsv() {
    window.open('/files/pedidoderecargacsv.txt');
  }

  React.useEffect(() => {
    getTitular();
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <Form ref={formRef} onSubmit={handleSubmit}>
            {errors.length > 0 && (
              <div className="erro">
                <div className="errosLength">{`Houve ${errors.length} erro de importação:`}</div>
                {errors.map((erro: any) => (
                  <>
                    <div className="descriptionErro" key={erro}>
                      {!!erro.InternalErrorMessage && erro.InternalErrorMessage}
                      {typeof erro === 'string' && erro}
                    </div>
                  </>
                ))}
              </div>
            )}
            {titular?.SelectedClient && titular?.SelectedClient ? (
              <p>
                Escolha um arquivo nos formatos txt ou csv para importar seus
                pedidos em massa.
              </p>
            ) : (
              <p>
                Escolha um arquivo no formato txt para importar seus pedidos em
                massa.
              </p>
            )}
            <p>
              Mas atenção, não deixe de conferir o{' '}
              <a
                href="/files/exemploPedidoderecarga.txt"
                target="_blank"
                className="txt"
                onClick={importFile}
                download="exemploPedidoderecarga.txt"
                style={{
                  textDecoration: 'underline',
                  color: '#3F1159',
                }}
              >
                arquivo de exemplo em txt
              </a>
              .
            </p>
            {titular?.SelectedClient && (
              <p>
                Ou então utilize o{' '}
                <a
                  href="/files/exemplopedidoderecargacsv.csv"
                  target="_blank"
                  className="txt"
                  onClick={importFilecsv}
                  download="exemplopedidoderecargacsv.csv"
                  style={{
                    textDecoration: 'underline',
                    color: '#3F1159',
                  }}
                >
                  arquivo de exemplo em csv
                </a>
                .
                <p>
                  <strong>Atenção! </strong>Não é permitido a importação de
                  arquivos em <strong>CSV</strong> caso os dados para importação
                  do funcionario contenham acentuações
                  <strong> ( ~^´Ç etc)</strong>.
                </p>
              </p>
            )}
            <div className="buttonImport">
              <File
                name="ArquivoImportacao"
                title="Escolher arquivo"
                accept={titular?.SelectedClient ? '.txt, .csv' : '.txt'}
              />
            </div>
            <div className="buttonsContainer">
              <Button
                color="orange"
                padding="1"
                type="button"
                className="cancelar"
                onClick={handleClose}
              >
                CANCELAR
              </Button>

              <Button
                color="orange"
                padding="1"
                type="submit"
                className="enviar"
              >
                ENVIAR
              </Button>
            </div>
          </Form>
        )}
      </Modal>
    </Container>
  );
};

export default CreateOrderByImport;
